export default __webpack_public_path__ + "static/media/wos_background_no_sea.6ce64665.png";